import api from '@/lib/api';

export const DEVICES_QUERY_KEY = ['devices'] as const;
export const GATEWAY_STATS_QUERY_KEY = ['gateway-stats'] as const;
export const API_KEYS_QUERY_KEY = ['auth-api-keys'] as const;
export const PROFILE_QUERY_KEY = ['auth-profile'] as const;

const ONE_MINUTE = 60_000;
const TWO_MINUTES = 120_000;

export const fetchDevices = async () => {
  const response = await api.get('/gateway/devices');
  return response.data?.data?.devices || [];
};

export const fetchGatewayStats = async () => {
  const response = await api.get('/gateway/stats');
  return response.data?.data;
};

export const fetchApiKeys = async () => {
  const response = await api.get('/auth/api-keys');
  const data = response.data?.data;
  if (Array.isArray(data)) {
    return data;
  }
  return data?.apiKeys || [];
};

export const fetchProfile = async () => {
  const response = await api.get('/auth/profile');
  return response.data;
};

export const fetchWhatsappGroups = async (deviceId: string) => {
  const response = await api.get(`/whatsapp/devices/${deviceId}/groups`);
  return response.data?.data?.groups || [];
};

export const devicesQueryOptions = () => ({
  queryKey: DEVICES_QUERY_KEY,
  queryFn: fetchDevices,
  staleTime: ONE_MINUTE,
  refetchInterval: TWO_MINUTES,
  refetchOnWindowFocus: false,
});

export const gatewayStatsQueryOptions = () => ({
  queryKey: GATEWAY_STATS_QUERY_KEY,
  queryFn: fetchGatewayStats,
  staleTime: ONE_MINUTE,
  refetchInterval: TWO_MINUTES,
  refetchOnWindowFocus: false,
});

export const apiKeysQueryOptions = () => ({
  queryKey: API_KEYS_QUERY_KEY,
  queryFn: fetchApiKeys,
  staleTime: ONE_MINUTE,
  refetchInterval: TWO_MINUTES,
  refetchOnWindowFocus: false,
});

export const profileQueryOptions = () => ({
  queryKey: PROFILE_QUERY_KEY,
  queryFn: fetchProfile,
  staleTime: TWO_MINUTES,
  refetchInterval: TWO_MINUTES * 2,
  refetchOnWindowFocus: false,
});

export const whatsappGroupsQueryOptions = (deviceId?: string) => ({
  queryKey: ['whatsapp-groups', deviceId] as const,
  queryFn: () => fetchWhatsappGroups(deviceId as string),
  enabled: !!deviceId,
  staleTime: ONE_MINUTE,
  refetchOnWindowFocus: false,
});
